import { render, staticRenderFns } from "./DynamicSlider.vue?vue&type=template&id=ce84d7ce&"
import script from "./DynamicSlider.vue?vue&type=script&lang=js&"
export * from "./DynamicSlider.vue?vue&type=script&lang=js&"
import style0 from "./DynamicSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports